import { useState } from 'react';
import {
  YardCompaniesPage,
  YardCompaniesHeader,
  YardCompaniesBody,
} from './YardCompaniesComponents';
import { RoleGuard } from '../../../routes';

export const YardCompanies = () => {
  const [totalCount, setTotalCount] = useState(0);

  return (
    <RoleGuard roles={['SUPER_ADMIN']}>
      <YardCompaniesPage id={'yardcompanies-page'} innerScroll>
        <YardCompaniesHeader totalCount={totalCount} />
        <YardCompaniesBody setTotalCount={setTotalCount} />
      </YardCompaniesPage>
    </RoleGuard>
  );
};
